class FeaturedIngredients {
  constructor(section) {
    this.section = section;
    this.grid = section.querySelector('.zenmen-ingredients-grid');
    this.button = section.querySelector('.zenmen-ingredients-view-more-btn');
    this.hiddenCards = section.querySelectorAll('.zenmen-ingredient-hidden');
    this.viewMoreText = this.button.querySelector('.zenmen-view-more-text');
    this.viewLessText = this.button.querySelector('.zenmen-view-less-text');
    this.isExpanded = false;

    this.init();
  }

  init() {
    if (this.button) {
      this.button.addEventListener('click', () => this.toggleExpand());
    }

    // Show all cards on mobile
    this.handleMobileView();
    window.addEventListener('resize', () => this.handleMobileView());
  }

  handleMobileView() {
    const isMobile = window.innerWidth <= 749;

    if (isMobile) {
      // Show all cards on mobile
      const allCards = this.section.querySelectorAll('.zenmen-ingredient-card');
      allCards.forEach(card => {
        card.classList.remove('zenmen-ingredient-hidden');
      });
    }
  }

  toggleExpand() {
    this.isExpanded = !this.isExpanded;
    this.button.setAttribute('data-expanded', this.isExpanded);

    if (this.isExpanded) {
      this.expandGrid();
    } else {
      this.collapseGrid();
    }
  }

  expandGrid() {
    // Add expanded class to grid
    this.grid.classList.add('expanded');

    // Show all hidden cards with animation
    const hiddenCards = this.section.querySelectorAll('.zenmen-ingredient-hidden');
    hiddenCards.forEach((card, index) => {
      setTimeout(() => {
        card.classList.remove('zenmen-ingredient-hidden');
        card.classList.add('zenmen-ingredient-showing');
      }, index * 50); // Stagger animation
    });

    // Update button text
    this.viewMoreText.style.display = 'none';
    this.viewLessText.style.display = 'inline';
  }

  collapseGrid() {
    // Remove expanded class from grid
    this.grid.classList.remove('expanded');

    // Get visible items count
    const visibleItems = parseInt(this.grid.getAttribute('data-visible-items'));

    // Hide cards beyond visible items
    const allCards = this.section.querySelectorAll('.zenmen-ingredient-card');
    allCards.forEach((card, index) => {
      const cardIndex = parseInt(card.getAttribute('data-index'));
      if (cardIndex > visibleItems) {
        card.classList.add('zenmen-ingredient-hidden');
        card.classList.remove('zenmen-ingredient-showing');
      }
    });

    // Update button text
    this.viewMoreText.style.display = 'inline';
    this.viewLessText.style.display = 'none';

    // Scroll to section top
    const sectionTop = this.section.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({
      top: sectionTop - 100,
      behavior: 'smooth'
    });
  }
}

// Initialize all featured ingredients sections
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.zenmen-ingredients-section');
  sections.forEach(section => {
    new FeaturedIngredients(section);
  });
});

// Handle Shopify theme editor
if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.zenmen-ingredients-section');
    if (section) {
      new FeaturedIngredients(section);
    }
  });
}
